import ResultDetail from "./ResultDetail";
export default ResultDetail